// @flow

import React, { Component } from 'react'
import styled from 'styled-components'
import { translateFunc, translations } from '../../shared/localize'
import Tooltip from '../Tooltip'
import Button from '../controls/PrimaryButton'

const StyledTooltip: any = styled(Tooltip)`
  display: inline-block !important;
`

const SegmentMenuButton: any = styled(Button)`
  padding-right: 24px;

  background-image: linear-gradient(45deg, transparent 50%, white 50%),
    linear-gradient(135deg, white 50%, transparent 50%),
    linear-gradient(to top, #1a89c1 0%, #2ab3d5 100%);
  background-position: calc(100% - 13px) calc(1em + 1px), calc(100% - 8px) calc(1em + 1px), left top;
  background-size: 5px 5px, 5px 5px, 100%;
  background-repeat: no-repeat;

  &:hover {
    background-image: linear-gradient(45deg, transparent 50%, white 50%),
      linear-gradient(135deg, white 50%, transparent 50%),
      linear-gradient(to top, #2ab3d5 0%, #2ab3d5 100%);
  }

  &:focus {
    background-image: linear-gradient(45deg, transparent 50%, white 50%),
      linear-gradient(135deg, white 50%, transparent 50%),
      linear-gradient(to top, #2ab3d5 0%, #2ab3d5 100%);
    box-shadow: inset rgba(0, 0, 0, 0.3) 0 1px 3px 0;
  }

  ${({ isFocused }: Object) => {
    return isFocused ? 'background-color: #61b8d3; color: white;' : ''
  }}
`

type Props = {|
  isOpen: boolean,
  onClick: Function,
  onClose: Function,
  children: any
|}

const t = translateFunc(translations.targeting_sources)

export default class SegmentMenu extends Component<Props> {
  render() {
    const { isOpen, onClick, onClose, children } = this.props

    return (
      <StyledTooltip
        hideArrow
        isInteractive
        distance={0}
        content={children}
        isOpen={isOpen}
        onClose={onClose}
        position="bottom-start"
      >
        <SegmentMenuButton
          isFocused={this.props.isOpen}
          small
          onClick={(event) => {
            event.preventDefault()
            onClick()
          }}
        >
          {t('create_segment')}
        </SegmentMenuButton>
      </StyledTooltip>
    )
  }
}
